import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../../modules/commons/Container";
import SimpleDDL from "../../../../modules/SimpleDDL";
import TabBBK from "./tabBBK/tabBBK";
import TabBBM from "./tabBBM/tabBBM";
import TabKwitansiBatal from "./tabKwitansiBatal/tabKwitansiBatal";
import TabStatus from "./tabStatus/tabStatus";
import { mapToObjectDDL } from "../../../common/mapper";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { getUserAccess } from "../../../../Services/Utils";

class TransaksiBank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            kodeCabang: null,
            loading: false,
            cabangOptions: [],
            submittedFilterData: {},
            userAccess: null
        };
    }

    componentDidMount() {
        this.fetchDataCabang()
    }

    componentDidUpdate(_, prevState) { 
        if(prevState.kodeCabang?.value !== this.state.kodeCabang?.value){
            this.setState({
                userAccess: getUserAccess(this.props.menuAccess, this.state.kodeCabang?.value)
            })
        }
    } 

    fetchDataCabang = async () =>{
        let options = [];
        if (this.props.menuAccess.length > 0) {
          this.setState((prevValue) => ({ ...prevValue, loading: true }));
          const responses = await Promise.all(
            this.props.menuAccess.map((ma) =>
              Api.create("NAGAMAS_MASTER_DATA").getMasterCabangById(ma.idRefObj)
            )
          );
          responses.forEach((r) => {
            if (r.ok) {
              options.push(
                mapToObjectDDL(r.data.data.namaDealer, r.data.data.kodeCabang)
              );
            }
          });
          this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: { ...options[0] },
            cabangOptions: [...options],
            userAccess: getUserAccess(this.props.menuAccess, options[0]?.value)
          }));
          this.setState((prevValue) => ({ ...prevValue, loading: false }));
        }
    }

    handleTabChange = (index) => {
        this.setState((prevValue) => ({ ...prevValue, tabIndex: index }));
    };

    handleChangeCabang = async (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: value,
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-250px"
                        placeholder="Nama cabang hak akses"
                        options={this.state.cabangOptions}
                        value={this.state.kodeCabang}
                        onChange={(value) => this.handleChangeCabang(value)}
                    />
                    <Tabs selectedIndex={this.state.tabIndex} onSelect={this.handleTabChange}>
                        <TabList>
                            <Tab>Status</Tab>
                            <Tab>BBM</Tab>
                            <Tab>BBK</Tab>
                            <Tab>Kwitansi Batal</Tab>
                        </TabList>
                        <TabPanel>
                            <TabStatus
                                {...this.props}
                                kodeCabang={this.state.kodeCabang}
                            />
                        </TabPanel>
                        <TabPanel>
                            <TabBBM
                                {...this.props}
                                kodeCabang={this.state.kodeCabang}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                        <TabPanel>
                            <TabBBK
                                {...this.props}
                                kodeCabang={this.state.kodeCabang}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                        <TabPanel>
                            <TabKwitansiBatal
                                {...this.props}
                                kodeCabang={this.state.kodeCabang}
                            />
                        </TabPanel>
                    </Tabs>
                    {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
                </Container>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(TransaksiBank);
